import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import Home from '@/components/Home'
import DeclaracaoInssCadastro from '@/components/pages/declaracao/DeclaracaoInssCadastro'
import DeclaracaoInssLista from '@/components/pages/declaracao/DeclaracaoInssLista';
import DeclaracaoInssGrafico from '@/components/pages/declaracao/DeclaracaoInssGrafico';
import TermoResponsabilidadeLista from '@/components/pages/termoResponsabilidade/TermoResponsabilidadeLista';
import LicencaPrevidenciariaLista from '@/components/pages/licencaPrevidenciaria/LicencaPrevidenciariaLista';
import LicencaPrevidenciariaCadastro from '@/components/pages/licencaPrevidenciaria/LicencaPrevidenciariaCadastro';
import DemonstrativoRepasseGrafico from '@/components/pages/demonstrativo/repasse/DemonstrativoRepasseGrafico';
import LinkUteis from '@/components/pages/linkUteis/LinkUteisLista';
import VueApexCharts from 'vue-apexcharts'
import VueLogger from 'vuejs-logger'
import money from 'v-money'
import moment from 'moment'
import VueProgressBar from 'vue-progressbar'
import cooperadowebapi from '../pluginCooperadoWebAPI'

/* Inicio Javascript */
const $ = require('jquery');
global.$ = $;
require('bootstrap');


$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})



/* Fim Javascript */


const isProduction = process.env.NODE_ENV === 'production';

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};
Vue.nextTick(function () {
  $('[data-toggle="tooltip"]').tooltip()
})
Vue.use(VueLogger, options);
Vue.use(Router)
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
  masked: false
})
Vue.use(VueProgressBar, {
  color: '#B3DC1A',
  failedColor: '#9A0000',
  height: '2px',
  thickness: '6px',
  transition: {
    speed: '0.2s',
    opacity: '0.8s',
    termination: 700
  },
  autoRevert: true,
  location: 'bottom',
  inverse: false
})
Vue.use(VueApexCharts)
Vue.use(cooperadowebapi)

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
});


Vue.filter('formatDateMonthYear', function(value) {
  if (value) {
    return moment(String(value)).format('MM/YYYY')
  }
});

Vue.filter('formatDatetime', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
});

Vue.filter('formatMoney', function(value) {
  if (value != undefined) {
    let val = (value/1).toFixed(2).replace('.', ',')
    return "R$ " + (val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."))
  }
});

Vue.filter('formatPercent', function(value) {
  if (value != undefined) {
    let val = (value/1).toFixed(2).replace('.', ',')
    return (val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."))+"%"
  }
});

Vue.filter('formatCNPJ', (value) => {
  value = (typeof value != 'string' ? value.toString() : value);
    value = value.padStart(14, '0');
    value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  
  return value;
});

Vue.component('apexchart', VueApexCharts)

let route = new Router({
  routes: [

    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/DeclaracaoInssCadastro',
      name: 'DeclaracaoInssCadastro',
      component: DeclaracaoInssCadastro
    },
    {
      path: '/DeclaracaoInssLista',
      name: 'DeclaracaoInssLista',
      component: DeclaracaoInssLista
    },
    {
      path: '/DeclaracaoInssGrafico',
      name: 'DeclaracaoInssGrafico',
      component: DeclaracaoInssGrafico
    },
    {
      path: '/TermoResponsabilidadeLista',
      name: 'TermoResponsabilidadeLista',
      component: TermoResponsabilidadeLista
    },
    {
      path: '/LicencaPrevidenciariaLista',
      name: 'LicencaPrevidenciariaLista',
      component: LicencaPrevidenciariaLista
    },
    {
      path: '/LicencaPrevidenciariaCadastro',
      name: 'LicencaPrevidenciariaCadastro',
      component: LicencaPrevidenciariaCadastro
    },
    {
      path: '/LinkUteisLista',
      name: 'LinkUteisLista',
      component: LinkUteis
    },



    
    
  ]
})

// passando parametros de alteracao do layout
route.beforeEach((to, from, next) => {
  if (Object.keys(from.query).length && JSON.stringify(from.query) !== JSON.stringify(to.query)) {
    next({ name: to.name, query: from.query, hash: to.hash, params: to.params })
  } else {
    next()
  }
})


export default route



// WEBPACK FOOTER //
// ./src/router/index.js